import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 登入 - 驗證手機 OTP 簡訊驗證碼
 */
const VerifyMobile = [
    'POST',
    RouteUrlList.API_VerifyMobile.path,
    {},
    200,
    {
        status: true,
        title: '驗證成功',
        message: '手機驗證碼驗證成功，登入完成',
        errorCode: ''
    }
];

export default VerifyMobile;
